import { Gallery } from '@components'

export class ModalGallery {
  /** модальное окно */
  private dialog: HTMLDialogElement
  /** элемент <picture> <source> */
  private source: HTMLSourceElement
  /** элемент <img> */
  private img: HTMLImageElement
  /** экземпляр открытой галереи */
  private gallery!: Gallery
  /** текущий номер открытой картинки */
  private currentIndex = 0
  /** счетчик номера картинки */
  private counter: HTMLOutputElement
  private startX = 0
  private startY = 0

  /**
   * @param dialog элемент <dialog>
   */
  constructor(dialog: HTMLDialogElement) {
    this.dialog = dialog
    this.source = this.dialog.querySelector<HTMLSourceElement>('source')!
    this.img = this.dialog.querySelector<HTMLImageElement>('img')!
    this.counter = this.dialog.querySelector<HTMLOutputElement>('output')!

    this.dialog.addEventListener('close', this.close.bind(this))
    this.dialog.addEventListener('keydown', this.keyHandler.bind(this))
    this.img.addEventListener('click', this.clickHandler.bind(this))
    this.img.addEventListener('pointerdown', this.pointerDown.bind(this))
    this.img.addEventListener('pointerup', this.pointerUp.bind(this))
  }

  /** Установить текущую галерею и картинку
   *  вызвать открытие <dialog>
   */
  public open(gallery: Gallery, index: number) {
    this.gallery = gallery
    this.currentIndex = index
    this.render()
    this.dialog.showModal()
    document.documentElement.attributeStyleMap.set('overflow', 'hidden')
  }

  /** Получить объект с информацией о картинке
   *  Установить ссылки в <source> и <img>
   */
  private render() {
    const item = this.gallery.getItem(this.currentIndex)

    const preload = new Image()
    this.img.hidden = true
    preload.src = item.src
    preload.onload = () => {
      this.source.srcset = item.src
      this.img.src = item.src
      this.img.alt = item.title
      this.img.hidden = false
    }

    this.source.srcset = item.src
    this.img.src = item.src
    this.img.alt = item.title
    this.counter.value = `${this.currentIndex + 1}/${this.gallery.length}`
  }

  /** Листать вправо */
  public next() {
    this.currentIndex = (this.currentIndex + 1) % this.gallery.length
    this.render()
  }

  /** Листать влево */
  public previous() {
    this.currentIndex--
    if (this.currentIndex < 0) this.currentIndex = this.gallery.length - 1
    this.render()
  }

  /** Закрытие модалки */
  private close() {
    document.documentElement.attributeStyleMap.delete('overflow')
    this.currentIndex = 0
    this.gallery = undefined!
    // снять фокус с кнопки мини-картинки, иначе будет баг с анимацией закрытия details
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur()
    }
  }

  /** Переключение стрелками */
  private keyHandler(event: KeyboardEvent) {
    switch (event.key) {
      case 'ArrowRight':
        this.next()
        break

      case 'ArrowLeft':
        this.previous()
        break

      case 'ArrowDown':
        this.dialog.close()
        break
    }
  }

  /** Переключение кликом */
  private clickHandler(event: MouseEvent) {
    const { width, left } = this.img.getBoundingClientRect()
    const x = event.clientX - left

    if (x < width / 2) {
      this.previous()
    } else {
      this.next()
    }
  }

  /** Обработка касания экрана */
  private pointerDown(event: PointerEvent) {
    this.img.setPointerCapture(event.pointerId)
    this.startX = event.clientX
    this.startY = event.clientY
  }

  /** Обработка касания экрана */
  private pointerUp(event: PointerEvent) {
    const deltaX = event.clientX - this.startX
    const deltaY = event.clientY - this.startY
    const absX = Math.abs(deltaX)
    const absY = Math.abs(deltaY)
    const threshold = 50
    if (absX < threshold && absY < threshold) return
    // вертикальный свайп вниз
    if (absY > absX && deltaY > threshold) {
      this.dialog.close()
      return
    }
    // горизонтальный свайп
    if (absX > absY) {
      if (deltaX < 0) {
        this.next()
      } else {
        this.previous()
      }
    }
  }
}
